import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

import { useThemeClassName } from '../../contexts/ThemeContext';
import Button from '../buttons/Button';
import Body from '../partials/Body';

import styles from '../../../styles/prizes/giftcard.module.scss';

const propTypes = {
    className: PropTypes.string,
    nameClassName: PropTypes.string,
    prize: AppPropTypes.prize,
};

const defaultProps = {
    className: null,
    nameClassName: null,
    prize: null,
};

function Giftcard({ className, nameClassName, prize }) {
    const { prize: prizeObject = null, giftcard = null } = prize || {};
    const { image = null, name = null, claimInstructions = null } = prizeObject || {};
    const { url: imageUrl = null } = image || {};
    const { pin = null, number = null, url: giftcardUrl = null } = giftcard || {};

    const themeClassName = useThemeClassName(styles);

    return (
        <div
            className={classNames([
                styles.container,
                themeClassName,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.imageContainer}>
                {imageUrl !== null ? (
                    <img className={styles.image} src={imageUrl} alt={name} />
                ) : null}
            </div>
            <div
                className={classNames([styles.name, { [nameClassName]: nameClassName !== null }])}
                dangerouslySetInnerHTML={{ __html: name }}
            />
            {number !== null || pin !== null ? (
                <div className={styles.numbers}>
                    {number !== null && giftcardUrl === null ? (
                        <div className={styles.data}>
                            <div className={styles.label}>
                                <FormattedMessage
                                    defaultMessage="Card number"
                                    description="Gift card label"
                                />
                            </div>
                            <div className={styles.value}>{number}</div>
                        </div>
                    ) : null}
                    {pin !== null ? (
                        <div className={styles.data}>
                            <div className={styles.label}>
                                <FormattedMessage
                                    defaultMessage="Your code"
                                    description="Gift card label"
                                />
                            </div>
                            <div className={styles.value}>{pin}</div>
                        </div>
                    ) : null}
                </div>
            ) : null}
            {giftcardUrl !== null ? (
                <Button href={giftcardUrl} external className={styles.link}>
                    <span className={styles.linkLabel}>
                        <FormattedMessage
                            defaultMessage="Get card"
                            description="Gift card link label"
                        />
                    </span>
                    <span className={styles.linkIcon}>
                        <FontAwesomeIcon icon={faChevronRight} />
                    </span>
                </Button>
            ) : null}
            {claimInstructions !== null ? (
                <Body className={styles.instructions} body={claimInstructions} />
            ) : null}
        </div>
    );
}

Giftcard.propTypes = propTypes;
Giftcard.defaultProps = defaultProps;

export default Giftcard;
